import { forwardRef } from "react";
import { Form } from "@shared/components";
import { FormAutocompleteProps } from "@shared/components/Form/types";
import { getCatalogsService } from "@modules/catalogs/services/queries/listCatalogs/service";

export const CatalogsAutocomplete = forwardRef<
  HTMLInputElement,
  Omit<FormAutocompleteProps, "options">
>((props, ref) => {

  return (
    <Form.Autocomplete
      {...props}
      ref={ref}
      queryHook={getCatalogsService}
    />
  );
});

CatalogsAutocomplete.displayName = "CatalogsAutocomplete";
